import { render, staticRenderFns } from "./IconHomeSolid.vue?vue&type=template&id=fc5f778a"
import script from "./IconHomeSolid.vue?vue&type=script&lang=js"
export * from "./IconHomeSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports